/* eslint-disable no-unused-vars */
/* eslint-disable prefer-const */
import React from 'react'

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  useHistory,
  useLocation
} from 'react-router-dom'
import Error from './Components/Error'
import LoginPage from './Components/LoginPage'
import Signup from './Components/Signup'
import UploadDocuments from './Components/UploadDocuments'
import PaymentSuccess from './Components/PaymentSuccess'
import './Main.css'
import Mains from './Components/Main'
const authentication = {
  isAuthenticated: false,
  authenticate () {
    authentication.isAuthenticated = true
  },
  signOut (cb) {
    sessionStorage.clear()
    authentication.isAuthenticated = false
    setTimeout(cb, 100)
  }
}

function Main (props) {
  const history = useHistory()
  let location = useLocation()
  let { from } = location.state || { from: { pathname: '/' } }

  let logout = () => {
    authentication.signOut(() => {
      history.replace(from)
    })
  }
  let submit = () => {
    history.replace('/upload')
  }
  return (
    // eslint-disable-next-line react/prop-types
    <Mains onClick={logout} onSubmit={submit} incompleteApplicationId={parseInt(props.incompleteApplicationId)} token={props.token} history={history}/>
  )
}
function Upload (props) {
  const history = useHistory()
  let location = useLocation()
  let { from } = location.state || { from: { pathname: '/' } }
  let logout = () => {
    authentication.signOut(() => {
      history.replace(from)
    })
  }
  return (
    // eslint-disable-next-line react/prop-types
    <UploadDocuments onClick={logout} incompleteApplicationId={parseInt(props.incompleteApplicationId)} history={history}/>
  )
}
function ErrorPage () {
  let history = useHistory()
  return (
    <Error onClick={() => history.push('/')} />
  )
}

// eslint-disable-next-line react/prop-types
function PrivateRoute ({ children, ...rest }) {
  let token = sessionStorage.getItem('token')
  let userId = sessionStorage.getItem('id')
  let expiry = sessionStorage.getItem('expiry')
  let nowDate = new Date()
  if (expiry >= nowDate.toString() && token && userId) {
    return (
      <Route
        {...rest}
        render={() =>
          (children)
        }
      />
    )
  } else {
    return (
      <Route
        {...rest}
        render={({ location }) =>
          (token && userId) ? (children) : (
            <Redirect
              to={{
                pathname: './login',
                state: { from: location }
              }}
              exact
            />
          )
        }
      />

    )
  }
}

let SESSION_TIMEOUT_MS = 20 * 60 * 1000 // default 20 minutes, updated from API

export default class App extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      incompleteApplicationId: 0,
      token: 0,
      email: '',
      sessionTimedOut: false
    }
    this.resetExpiry = this.resetExpiry.bind(this)
    this.checkExpiry = this.checkExpiry.bind(this)
  }

  componentDidMount () {
    // Fetch session timeout from API config
    fetch(`${process.env.REACT_APP_API_URL}/api/login/GetSessionTimeoutMinutes`)
      .then(res => res.text())
      .then(res => {
        const minutes = parseInt(res) || 20
        SESSION_TIMEOUT_MS = minutes * 60 * 1000
        window.__sessionTimeoutMs = SESSION_TIMEOUT_MS
      })
      .catch(() => {})

    // Track user activity to reset session expiry
    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart']
    events.forEach(e => window.addEventListener(e, this.resetExpiry))

    // Check expiry every 60 seconds
    this._expiryInterval = setInterval(this.checkExpiry, 60000)
  }

  componentWillUnmount () {
    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart']
    events.forEach(e => window.removeEventListener(e, this.resetExpiry))
    if (this._expiryInterval) clearInterval(this._expiryInterval)
  }

  resetExpiry () {
    // Only reset if user is logged in
    if (sessionStorage.getItem('token')) {
      const newExpiry = new Date(Date.now() + SESSION_TIMEOUT_MS)
      sessionStorage.setItem('expiry', newExpiry.toString())
    }
  }

  checkExpiry () {
    const token = sessionStorage.getItem('token')
    const expiry = sessionStorage.getItem('expiry')
    if (!token || !expiry) return // not logged in

    if (new Date() >= new Date(expiry)) {
      // Session expired — attempt to save form data before logout
      if (window.__appSave) {
        // Main form is active — save all form data
        window.__appSave().then(() => {
          sessionStorage.clear()
          window.onbeforeunload = null
          this.setState({ sessionTimedOut: true })
        }).catch(() => {
          sessionStorage.clear()
          window.onbeforeunload = null
          this.setState({ sessionTimedOut: true })
        })
      } else {
        // Upload page or no form data — just logout (data already saved from Next)
        sessionStorage.clear()
        window.onbeforeunload = null
        this.setState({ sessionTimedOut: true })
      }
    }
  }

  render () {
    const { incompleteApplicationId, token, email, sessionTimedOut } = this.state

    if (sessionTimedOut) {
      return (
        <div id='mainContainer'>
          <div id='designBorder'></div>
          <div id='main-page' style={{ textAlign: 'center', padding: '60px 20px' }}>
            <div style={{ fontSize: 48, color: '#c57000', marginBottom: 20 }}>&#9202;</div>
            <h3 style={{ color: '#3168CE', marginBottom: 16 }}>Session Expired</h3>
            <p style={{ fontSize: 16, color: '#333', lineHeight: 1.6, marginBottom: 12 }}>
              Your session has expired due to inactivity.
            </p>
            <p style={{ fontSize: 14, color: '#555', lineHeight: 1.6, marginBottom: 20 }}>
              Your application has been saved automatically. You can log in again to continue where you left off.
            </p>
            <button
              className='save'
              style={{ padding: '10px 24px', fontSize: 14 }}
              onClick={() => {
                this.setState({ sessionTimedOut: false })
                window.location.replace(window.location.pathname.split('/').slice(0, -1).join('/') + '/login')
              }}
            >
              Go to Login
            </button>
          </div>
        </div>
      )
    }

    return (
      <Router basename={'/PGApplicationForm'}>
        <Switch>
          <Route path="/login"
            render={(props) => (
              <LoginPage {...props} onLogin={(email, id, token) => {
                this.setState({ incompleteApplicationId: id, token: token, email: email })
                authentication.authenticate()
              }}/>
            )}
          >
          </Route>
          <Route path="/payment-success" component={PaymentSuccess} />
          <Route path="/signup"
            render={(props) => (
              <Signup {...props} onLogin={(email, id, token) => {
                this.setState({ incompleteApplicationId: id, token: token, email: email })
                authentication.authenticate()
              }}/>
            )}
          >
          </Route>

          <PrivateRoute path="/" exact>
            <Main incompleteApplicationId={ incompleteApplicationId} token={ token} email={ email}/>

          </PrivateRoute>
          <PrivateRoute path="/upload">
            <Upload
              incompleteApplicationId={ incompleteApplicationId}
              token={ token}
            />
          </PrivateRoute>
          <Route component={ErrorPage} />
        </Switch>
      </Router>
    )
  }
}
